module.exports = __webpack_public_path__ + "img/BE0806743159.7233166c.png";